module.exports = __webpack_public_path__ + "img/CoverCropped.6deea85d.webp";